import { render, staticRenderFns } from "./lotto-purchased.vue?vue&type=template&id=beced08e&scoped=true&"
import script from "./lotto-purchased.vue?vue&type=script&lang=js&"
export * from "./lotto-purchased.vue?vue&type=script&lang=js&"
import style0 from "./lotto-purchased.vue?vue&type=style&index=0&id=beced08e&prod&scoped=true&lang=css&"
import style1 from "./lotto-purchased.vue?vue&type=style&index=1&id=beced08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beced08e",
  null
  
)

export default component.exports